import React, { useContext } from "react";
import { NavLink, Link, useNavigate,useLocation } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useContext(UserContext);

   const isTestRunActive =
    location.pathname.startsWith("/admin/test-run-management") ||
    location.pathname.startsWith("/admin/test-run-view");

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const menuItems = [
    {
      path: "/admin/dashboard",
      icon: (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.75 18.0834C15.75 15.8835 15.75 14.7836 16.4334 14.1002C17.1168 13.4167 18.2168 13.4167 20.4167 13.4167C22.6166 13.4167 23.7165 13.4167 24.3999 14.1002C25.0833 14.7836 25.0833 15.8835 25.0833 18.0834V20.4167C25.0833 22.6166 25.0833 23.7166 24.3999 24.4C23.7165 25.0834 22.6166 25.0834 20.4167 25.0834C18.2168 25.0834 17.1168 25.0834 16.4334 24.4C15.75 23.7166 15.75 22.6166 15.75 20.4167V18.0834Z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2.33337 9.91675C2.33337 12.1166 2.33337 13.2166 3.01679 13.9C3.70021 14.5834 4.80015 14.5834 7.00004 14.5834C9.19993 14.5834 10.2999 14.5834 10.9833 13.9C11.6667 13.2166 11.6667 12.1166 11.6667 9.91675V7.58341C11.6667 5.38353 11.6667 4.28358 10.9833 3.60017C10.2999 2.91675 9.19993 2.91675 7.00004 2.91675C4.80015 2.91675 3.70021 2.91675 3.01679 3.60017C2.33337 4.28358 2.33337 5.38353 2.33337 7.58342V9.91675Z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M15.75 6.41675C15.75 5.32955 15.75 4.78595 15.9276 4.35715C16.1644 3.78542 16.6187 3.33118 17.1904 3.09436C17.6192 2.91675 18.1628 2.91675 19.25 2.91675H21.5833C22.6705 2.91675 23.2141 2.91675 23.6429 3.09436C24.2147 3.33118 24.6689 3.78542 24.9057 4.35715C25.0833 4.78595 25.0833 5.32955 25.0833 6.41675C25.0833 7.50394 25.0833 8.04754 24.9057 8.47634C24.6689 9.04807 24.2147 9.50231 23.6429 9.73913C23.2141 9.91675 22.6705 9.91675 21.5833 9.91675H19.25C18.1628 9.91675 17.6192 9.91675 17.1904 9.73913C16.6187 9.50231 16.1644 9.04807 15.9276 8.47634C15.75 8.04754 15.75 7.50394 15.75 6.41675Z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2.33337 21.5833C2.33337 22.6704 2.33337 23.214 2.51099 23.6428C2.74781 24.2146 3.20205 24.6688 3.77378 24.9056C4.20258 25.0833 4.74618 25.0833 5.83337 25.0833H8.16671C9.2539 25.0833 9.7975 25.0833 10.2263 24.9056C10.798 24.6688 11.2523 24.2146 11.4891 23.6428C11.6667 23.214 11.6667 22.6704 11.6667 21.5833C11.6667 20.4961 11.6667 19.9525 11.4891 19.5237C11.2523 18.9519 10.798 18.4977 10.2263 18.2609C9.7975 18.0833 9.2539 18.0833 8.16671 18.0833H5.83337C4.74618 18.0833 4.20258 18.0833 3.77378 18.2609C3.20205 18.4977 2.74781 18.9519 2.51099 19.5237C2.33337 19.9525 2.33337 20.4961 2.33337 21.5833Z" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      text: "Dashboard"
    },
    {
      path: "/admin/user-management",
      icon: (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10.4999" cy="6.99992" r="4.66667" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M17.5 10.5C19.433 10.5 21 8.933 21 7C21 5.067 19.433 3.5 17.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <ellipse cx="10.4999" cy="19.8334" rx="8.16667" ry="4.66667" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M21 16.3333C23.0466 16.7821 24.5 17.9187 24.5 19.2499C24.5 20.4508 23.3173 21.4933 21.5833 22.0154" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      text: "User Management"
    },
    {
      path: "/admin/test-run-management",
      icon: (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.33337 15.1667H14.2534" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M9.33337 10.1667H12.2534" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M9.33337 19.8333H19.0834" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M23.1332 3.70009C21.7663 2.33325 19.5664 2.33325 15.1667 2.33325H12.8333C8.43356 2.33325 6.23367 2.33325 4.86684 3.70009C3.5 5.06692 3.5 7.26681 3.5 11.6666V16.3333C3.5 20.733 3.5 22.9329 4.86684 24.2998C6.23367 25.6666 8.43356 25.6666 12.8333 25.6666H15.1667C19.5664 25.6666 21.7663 25.6666 23.1332 24.2998C24.2334 23.1995 24.448 21.5594 24.4899 18.6666" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M18 7.11137C17.9999 6.91588 18.0521 6.72383 18.1512 6.55462C18.2504 6.38541 18.3929 6.24503 18.5646 6.14765C18.7362 6.05027 18.9308 5.99934 19.1287 6.00001C19.3267 6.00067 19.5209 6.0529 19.6919 6.15143L26.4397 10.039C26.61 10.1365 26.7513 10.2766 26.8497 10.445C26.948 10.6135 26.9998 10.8045 27 10.999C27.0002 11.1934 26.9487 11.3845 26.8506 11.5531C26.7526 11.7218 26.6115 11.8621 26.4413 11.9599L19.6919 15.8486C19.5209 15.9471 19.3267 15.9993 19.1287 16C18.9308 16.0007 18.7362 15.9497 18.5646 15.8523C18.3929 15.755 18.2504 15.6146 18.1512 15.4454C18.0521 15.2762 17.9999 15.0841 18 14.8886V7.11137Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      text: "Test Run Management",
      customActive: isTestRunActive,
    },
    {
      path: "/admin/master-test-folder",
      icon: (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5833 22.1667H5.83333C5.21449 22.1667 4.621 21.9209 4.18342 21.4833C3.74583 21.0457 3.5 20.4523 3.5 19.8334V7.00008C3.5 6.38124 3.74583 5.78775 4.18342 5.35017C4.621 4.91258 5.21449 4.66675 5.83333 4.66675H10.5L14 8.16675H22.1667C22.7855 8.16675 23.379 8.41258 23.8166 8.85017C24.2542 9.28775 24.5 9.88124 24.5 10.5001V14.0001M22.1678 24.5001C21.549 24.5001 20.9555 24.2542 20.5179 23.8167C20.0803 23.3791 19.8345 22.7856 19.8345 22.1667C19.8345 21.5479 20.0803 20.9544 20.5179 20.5168C20.9555 20.0792 21.549 19.8334 22.1678 19.8334M22.1678 24.5001C22.7867 24.5001 23.3802 24.2542 23.8177 23.8167C24.2553 23.3791 24.5012 22.7856 24.5012 22.1667C24.5012 21.5479 24.2553 20.9544 23.8177 20.5168C23.3802 20.0792 22.7867 19.8334 22.1678 19.8334M22.1678 24.5001V26.2501M22.1678 19.8334V18.0834M25.704 20.1251L24.1885 21.0001M20.1483 23.3334L18.6317 24.2084M18.6317 20.1251L20.1483 21.0001M24.1885 23.3334L25.7052 24.2084" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 14H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      text: "Master Test Folder"
    }
  ];

  return (
    <aside className="sidebar">
      <div className="logo">
        <Link to="/admin/dashboard">
          <img src="/images/logo_icon.png" className="img-fluid" alt="logo" />
        </Link>
      </div>
      <div className="sidebar_menu">
         <ul className="menu">
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  item.customActive || isActive ? "active" : ""
                }
              >
                {item.icon}
                <span>{item.text}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <ul className="logout">
          <li>
            <button 
              onClick={handleLogout}
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%'
              }}
            >
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.33447 13.9988L18.6678 13.9988M18.6678 13.9988L14.5845 10.4988M18.6678 13.9988L14.5845 17.4988" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10.5022 8.16659C10.5163 5.62905 10.6288 4.25483 11.5253 3.35838C12.5504 2.33325 14.2003 2.33325 17.5002 2.33325L18.6668 2.33325C21.9667 2.33325 23.6166 2.33325 24.6417 3.35838C25.6668 4.3835 25.6668 6.03342 25.6668 9.33325L25.6668 18.6666C25.6668 21.9664 25.6668 23.6163 24.6417 24.6415C23.6166 25.6666 21.9667 25.6666 18.6668 25.6666L17.5002 25.6666C14.2003 25.6666 12.5504 25.6666 11.5253 24.6415C10.6288 23.745 10.5163 22.3708 10.5022 19.8333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span>Log Out</span>
            </button>
          </li>
        </ul>

        
      </div>
    </aside>
  );
};

export default Sidebar;